import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ShFormControl } from '../form-control/form-control.base';

/**
 * On/off switch; the value is a boolean. An optional `label` sits beside it.
 *
 *   <sh-toggle [(value)]="isPublic" ariaLabel="shared.terms.isPublic" />
 *
 * The switch has a single size (PrimeNG has no size for it), so `size` is
 * accepted for a uniform API but has no effect.
 */
@Component({
  selector: 'sh-toggle',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, FormsModule, TranslateModule, ToggleSwitchModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShToggleComponent),
      multi: true,
    },
  ],
  host: { class: 'sh-control', '[class.sh-invalid]': 'isInvalid()' },
  template: `
    <p-toggleswitch
      [ngModel]="!!value()"
      (ngModelChange)="commit($event)"
      [ngModelOptions]="{ standalone: true }"
      [inputId]="controlId()"
      [ariaLabel]="ariaLabel() | translate"
      [readonly]="isReadonly()"
      [disabled]="isDisabled()"
    ></p-toggleswitch>
    <label *ngIf="label()" [attr.for]="controlId()">{{
      label() | translate
    }}</label>
  `,
})
export class ShToggleComponent extends ShFormControl<boolean> {
  /** Translation key or plain text, shown beside the switch. */
  readonly label = input<string>();
}
